
      import {versionApi} from './config.js';
      
      if(!window.customElements.get('dw-app')) {
        fetch(versionApi)
          .then((response) => {
            if(!response.ok) {
              //  error on request
            }
            return response.json();
          }).then((parsedResponse) => {
            if(parsedResponse.url) {
              import(parsedResponse.url).then((module) => {
                window.customElements.define('dw-app', module.DwApp);
                const dwApp = window.document.createElement('dw-app');
                dwApp.setAttribute('direct-api', parsedResponse.directApiLink);
                document.querySelector('body').appendChild(dwApp);
              });
            }
          });
      }
    